module.exports = __webpack_public_path__ + "static/media/SofiaProBold.6816ba28.woff";